/*global VDMapTileGrid */

import 'core-js/modules/es.typed-array.set';
import ImageLayer from 'ol/layer/Image';
import TileLayer from 'ol/layer/Tile';
import { ImageWMS, TileWMS, WMTS } from 'ol/source';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { password, username } from './datafordeler';

const vmGeoCloudUrl = '//geocloud.vd.dk/VM/ows';
const vejmanStamdataUrl = 'https://geocloud.vd.dk/vejman-stamdata/ows'
const dagiUrl = 'https://services.datafordeler.dk/DAGIM/dagi/1.0.0/WMS';

const skaermkortTileGrid = new WMTSTileGrid({
    extent: [120000, 5900000, 1000000, 6500000],
    resolutions: [1638.4, 819.2, 409.6, 204.8, 102.4, 51.2, 25.6, 12.8, 6.4, 3.2, 1.6, 0.8, 0.4, 0.2],
    matrixIds: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13']
});
const ortofotoTileGrid = new WMTSTileGrid({
    extent: [120000, 5900000, 1000000, 6500000],
    resolutions: [1638.4, 819.2, 409.6, 204.8, 102.4, 51.2, 25.6, 12.8, 6.4, 3.2, 1.6, 0.8, 0.4, 0.2, 0.1, 0.05],
    matrixIds: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15']
});

export function topoSkaermKort() {
    return new TileLayer({
        title: 'Skærmkort',
        type: 'base',
        source: new WMTS({
            url: `https://services.datafordeler.dk/DKskaermkort/topo_skaermkort_wmts/1.0.0/wmts?username=${username}&password=${password}`,
            layer: 'topo_skaermkort',
            matrixSet: 'View1',
            format: 'image/jpeg',
            tileGrid: skaermkortTileGrid,
            style: 'default'
        }),
        preload: Infinity
    });
}

export function ortofoto() {
    return new TileLayer({
        title: 'Luftfoto',
        type: 'base',
        source: new WMTS({
            url: `https://services.datafordeler.dk/GeoDanmarkOrto/orto_foraar_wmts/1.0.0/WMTS?username=${username}&password=${password}`,
            layer: 'orto_foraar_wmts',
            matrixSet: 'KortforsyningTilingDK',
            format: 'image/jpeg',
            tileGrid: ortofotoTileGrid,
            style: 'default'
        }),
        preload: Infinity
    });
}

export function address(maxResolution) {
    return new TileLayer({
        title: "Husnumre",
        visible: false,
        maxResolution,
        source: new TileWMS({
            url: 'https://kort.aws.dk/geoserver/aws4_wms/wms',
            params: {
                LAYERS: "adgangsadresser",
                TRANSPARENT: 'TRUE',
                STYLES: 'SortMedHalo'
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function cvf(maxResolution) {
    return new TileLayer({
        title: "CVF-veje",
        visible: false,
        maxResolution: maxResolution,
        source: new TileWMS({
            url: "//geocloud.vd.dk/CVF/wms",
            params: {
                LAYERS: "veje",
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function helkm(maxResolution) {
    return new TileLayer({
        title: 'Helkilometre',
        visible: false,
        maxResolution: maxResolution,
        source: new TileWMS({
            url: vejmanStamdataUrl,
            params: {
                LAYERS: 'km-maerker',
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function busruter() {
    return new TileLayer({
        title: 'Busruter',
        visible: false,
        source: new TileWMS({
            url: vmGeoCloudUrl,
            params: {
                LAYERS: 'busruter'
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function blockingSimple() {
    return new TileLayer({
        title: 'Spærretider (simple)',
        visible: false,
        source: new TileWMS({
            url: vmGeoCloudUrl,
            params: {
                LAYERS: 'spaerretider_kommune'
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function blockingAdvanced() {
    return new TileLayer({
        title: 'Spærretider (avancerede)',
        visible: false,
        source: new TileWMS({
            url: vmGeoCloudUrl,
            params: {
                LAYERS: 'spaerretider'
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function municipalityBorders() {
    return new TileLayer({
        title: 'Kommunegrænser',
        visible: false,
        source: new TileWMS({
            url: dagiUrl,
            params: {
                LAYERS: 'Kommuneinddeling',
                TRANSPARENT: 'TRUE',
                username,
                password
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function politikredse() {
    return new TileLayer({
        title: 'Politikredse',
        visible: false,
        source: new TileWMS({
            url: dagiUrl,
            params: {
                LAYERS: 'Politikreds',
                TRANSPARENT: 'TRUE',
                username,
                password
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function hastighed() {
    return new TileLayer({
        title: 'Hastighedsgrænser',
        visible: false,
        source: new TileWMS({
            url: vmGeoCloudUrl,
            params: {
                LAYERS: 'hastighedsgraenser',
            },
            tileGrid: VDMapTileGrid
        })
    });
}

export function frededeVeje() {
    return new ImageLayer({
        title: 'Fredede veje',
        visible: false,
        source: new ImageWMS({
            url: 'https://geocloud.vd.dk/vejman-stamdata/wms',
            params: {
                layers: 'fredede-veje'
            }
        })
    });
}
